// material-ui
import { Box } from '@mui/material';

import {
    Tooltip,
    IconButton,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import DeleteAlert from './DeleteAlert';

// third party
import moment from 'moment';

const CancellationList = ({ rows, setReload, handleOpen }) => {

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ pl: 3 }} align="center">#</TableCell>
                                <TableCell align="center">Range</TableCell>
                                <TableCell align="center">Deduction Percentage</TableCell>
                                <TableCell align="center">Created At</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((row, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell sx={{ pl: 3 }} align="center">{index + 1}</TableCell>
                                        <TableCell align="center">{row.start}{row.end ? ' - ' + row.end : ''} hrs</TableCell>
                                        <TableCell align="center">{row.percentage}%</TableCell>
                                        <TableCell align="center">
                                            {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Tooltip placement="top" title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="edit"
                                                    size="large"
                                                    onClick={() => handleOpen(row.uuid)}
                                                >
                                                    <EditIcon sx={{ fontSize: '1.1rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <DeleteAlert setReload={setReload} ruleUuid={row.uuid} />
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </MainCard>
        </Box>
    );
};

export default CancellationList;
